// utils/encryption.js
// Convert a Uint8Array to base64
function toBase64(arr) {
  return btoa(String.fromCharCode(...arr));
}

// Convert base64 to Uint8Array
function fromBase64(str) {
  return Uint8Array.from(atob(str), (c) => c.charCodeAt(0));
}

async function importKeyFromSalt(salt) {
  return window.crypto.subtle.importKey("raw", salt, { name: "AES-GCM", length: 256 }, false, [
    "encrypt",
    "decrypt",
  ]);
}

export const generateSalt = (string) => {
  // if (!string) return null;
  // const hashHex = sha256(string); // returns a hex string
  // // convert hex string to Uint8Array if you need bytes
  // const bytes = new Uint8Array(hashHex.match(/.{2}/g).map((byte) => parseInt(byte, 16)));
  // return bytes; // 32 bytes
};
export async function encryptObject(obj, salt) {
  const key = await importKeyFromSalt(salt);
  const iv = window.crypto.getRandomValues(new Uint8Array(12)); // must be unique per encryption
  const enc = new TextEncoder();
  const data = enc.encode(JSON.stringify(obj));

  const ciphertext = await window.crypto.subtle.encrypt({ name: "AES-GCM", iv }, key, data);

  const payload = {
    v: 1,
    iv: toBase64(iv),
    data: toBase64(new Uint8Array(ciphertext)),
  };

  return btoa(JSON.stringify(payload));
}

export async function decryptObject(payloadB64, salt) {
  const payloadJson = atob(payloadB64);
  const payload = JSON.parse(payloadJson);

  if (payload.v !== 1) throw new Error("Unsupported version");

  const key = await importKeyFromSalt(salt);
  const iv = fromBase64(payload.iv);
  const data = fromBase64(payload.data);

  const decrypted = await window.crypto.subtle.decrypt({ name: "AES-GCM", iv }, key, data);

  const dec = new TextDecoder();
  return JSON.parse(dec.decode(decrypted));
}

function xorEncryptDecrypt(input, key) {
  let output = "";
  for (let i = 0; i < input.length; i++) {
    // XOR char code with key char code (cycling through key)
    const charCode = input.charCodeAt(i) ^ key.charCodeAt(i % key.length);
    output += String.fromCharCode(charCode);
  }
  return output;
}

export function encodeObject(obj, key) {
  const jsonString = JSON.stringify(obj);
  // XOR encrypt the JSON string with the key
  const xored = xorEncryptDecrypt(jsonString, key);
  // Base64 encode the result
  return btoa(xored);
}

// export function decodeObject(encodedStr, key) {
//   // Base64 decode
//   if (!encodedStr) return {};
//   const xored = atob(encodedStr);
//   // XOR decrypt with the key
//   const jsonString = xorEncryptDecrypt(xored, key);
//   return JSON.parse(jsonString);
// }

export function decodeObject(encodedStr, key) {
  if (!encodedStr || typeof encodedStr !== "string") return {};

  try {
    // Fix URL-safe base64 if present
    const normalized = encodedStr.replace(/-/g, "+").replace(/_/g, "/");

    const xored = atob(normalized);

    const jsonString = xorEncryptDecrypt(xored, key);

    return JSON.parse(jsonString);
  } catch (error) {
    console.error("decodeObject error:", error, encodedStr);

    // Fallback: try parsing directly (in case it's already JSON)
    try {
      return JSON.parse(encodedStr);
    } catch {
      return {};
    }
  }
}
